import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../../assets/images/icons/burger.svg'


const _hoisted_1 = { class: "burger-btn" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" МЕНЮ ")
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "burger-icon",
  src: _imports_0
}, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("button", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
}